

export const CheckIcon = () =>{

  return (
    <svg width="16" height="12" viewBox="0 0 18 14" fill="urre" xmlns="http://www.w3.org/2000/svg">
      <path d="M17.5 1.41L5.5 13.41L0 7.91L1.41 6.5L5.5 10.58L16.09 0L17.5 1.41Z" fill="currentcolor"/>
    </svg>
  )
}